import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

const CareersBanner = () => {
    return (
        <div>
            <video
                className="banner-wrapper"
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                disablePictureInPicture
                controlsList="nodownload noplaybackrate nofullscreen"
            >
                <source 
                    src={require('../../../assets/videos/headervideo/header-video.mp4')} 
                    type="video/mp4"
                />
            </video>
      
            <div className="gradient-overlay">
                <Container className="py-5" >
                    <Row className="d-flex align-items-center justify-content-center">
                        <Col xxl={6} xl={6} lg={10} md={10} sm={12} xs={12} className="text-center">
                            <p className="fs-28 fw-400 sub-header text-black mb-1">
                                Careers
                            </p>
                            <p className='fw-400 header'>
                                Explore your opportunities at JoynJoyy
                            </p>
                            <p className='sub-heading-text fw-400 text-black'>
                                We, at Joy n Joyy Waterpark, focus on providing you with a career that offers challenges and growth. We encourage innovative ideas and thoughts that lead to success and emerging opportunities.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default CareersBanner
